var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"72vh"}},[_c('div',{staticClass:"banner",style:({backgroundImage:('url('+_vm.banner+')')}),attrs:{"id":"investor_banner1"}},[_c('span',[_vm._v(_vm._s(_vm.$t("indexnav.Financial Reports"))),_c('i',{style:({
          display: this.$store.state.nowlanguage === 'en' ? 'none' : '',
        })},[_vm._v("Financial Reports")])])]),_c('section',{staticClass:"ab-item1"},[_c('bread-crumb')],1),_c('div',{attrs:{"id":"iframeContainer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }